<!--
    Desarrollado por: Yonathan Aviles
    // Fecha: 2022/09/05
    // Modificado por: 
    // Fecha de ultima Modificacion:   
    // Causa: 
    Historial de Modificaciones
    // Fecha Modificación: 2022/09/05
    // Modificación: Creación del componente
    /////////////////////////////////////////////////
-->

<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema />
    <v-row>
      <v-col cols="12">
        <v-toolbar color="primary d-flex justify-center rounded-lg" dense>
          <v-toolbar-title color="primary">
            <span class="white--text"> Buzón de mensajería </span>
          </v-toolbar-title>
        </v-toolbar>
      </v-col>
      <v-col cols="12" md="3" lg="3">
        <v-card elevation="1" outlined>
          <v-list dense nav>
            <v-list-item-group color="primary">
              <v-list-item v-for="(item, i) in options" :key="i" @click="onSelectedItem(i)">
                <v-list-item-icon v-if="item.icon">
                  <v-icon small :color="item.colorIcon">
                    {{ item.icon }}
                  </v-icon>
                </v-list-item-icon>
                <v-row class="px-1 py-1" v-if="i == 0">
                  <v-col cols="12">
                    <TableButtonComp normalButton blockButton :textButton="item.text" iconBut="fas fa-plus" />
                  </v-col>
                </v-row>
                <v-list-item-content v-if="i > 0">
                  <v-list-item-title>{{
                    i == 1
                    ? `${item.text} (${totalRecibidos})`
                    : i == 3
                      ? `${item.text} (${totalBorradores})`
                      : item.text
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" md="9" lg="9">
        <!-- Nuevo Mensaje -->
        <NuevoMensaje v-if="selectedItem == 0" :mensaje="mensaje" :borrador="borrador" :destinatarios="destinatariosBase"
          :titulo="options[selectedItem].title" @post-enviar-mensaje="postEnviarMensaje"
          @post-cancel-mensaje="postCancelEmail" @post-change-mensaje="postChangeMensaje" @reset-countdown="resetCountdown"></NuevoMensaje>

        <!-- Mensajes Recibidos -->
        <Mensajes key="recibidos" v-else-if="selectedItem == 1" :search="search" :titulo="options[selectedItem].title"
          :mensajes="mensajesRecibidosFilter" @volver="volver" @delete-messages="recicleMensajes"
          @filtrar-mensajes-no-leidos="filtrarMensajesNoLeidos" @marcar-leido="marcarLeido"
          @select-mensaje="selectMensaje" :isRecibidos="true" :isViewMessaje="isViewMessaje"></Mensajes>

        <!-- Mensajes Enviados -->
        <Mensajes key="enviados" v-else-if="selectedItem == 2" :search="search" :titulo="options[selectedItem].title"
          :mensajes="mensajesEnviados" @volver="volver" @delete-messages="recicleMensajes" @select-mensaje="selectMensaje"
          :isEnviados="true" :isViewMessaje="isViewMessaje"></Mensajes>

        <!-- Borradores -->
        <Mensajes key="borradores" v-else-if="selectedItem == 3" :search="search" :titulo="options[selectedItem].title"
          :mensajes="borradores" @volver="volver" @delete-messages="deleteBorradores" @select-mensaje="selectMensaje"
          :isBorradores="true" :isViewMessaje="isViewMessaje"></Mensajes>

        <Mensajes key="eliminados" v-else d-flex justify-endif="selectedItem == 4" :search="search"
          :titulo="options[selectedItem].title" :mensajes="mensajesEliminados" @volver="volver"
          @delete-messages="openModalDeleteMensajes" @select-mensaje="selectMensaje" :isEliminados="true"
          :isViewMessaje="isViewMessaje"></Mensajes>
      </v-col>
    </v-row>

    <!-- modal de borrar Mensajes    -->
    <v-dialog v-model="modalDelete" width="550">
      <v-card>
        <v-card-title class="btn_ver">
          <v-row class="d-flex justify-space-between py-0">
            Confirmar
            <v-btn fab dark x-small class="btn_style3" @click="modalDelete = false"><v-icon dark>fa-times</v-icon></v-btn>
          </v-row>
        </v-card-title>

        <v-card-text class="text-center black--text">
          <h3>¿Está seguro de borrar estos mensajes?</h3>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn_style3" dark @click="modalDelete = false">No</v-btn>
          <v-btn class="btn_block_style2" dark @click="deleteMensajes()">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- fin de modal de borrar Mensajes -->
  </div>
</template>

<script>
import axios from "../../../helpers/axios";
import { mapMutations, mapActions } from "vuex";
import TableButtonComp from "../../../components/ComponentsEst/TableButtonComp.vue";

// Components
import Mensajes from "./components/Mensajes.vue";
import NuevoMensaje from "./components/NuevoMensaje.vue";

export default {
  name: "Mensajeria",
  components: {
    Mensajes,
    NuevoMensaje,
    TableButtonComp,
  },
  data: () => ({
    modalDelete: false,
    isViewMessaje: false,
    selectedItem: 1,
    options: [
      {
        text: "Nuevo Mensaje",
        title: "Nuevo mensaje",
      },
      {
        text: "Mensajes recibidos",
        icon: "fa-inbox",
        colorIcon: "primary darken-2",
        title: "Mensajes recibidos",
      },
      {
        text: "Mensajes enviados",
        icon: "fa-paper-plane",
        colorIcon: "primary darken-2",
        title: "Mensajes enviados",
      },
      {
        text: "Borradores",
        icon: "fa-clone",
        colorIcon: "primary darken-2",
        title: "Borradores",
      },
      {
        text: "Mensajes eliminados",
        icon: "fa-trash-alt",
        colorIcon: "red darken-2",
        title: "Mensajes eliminados",
      },
    ],
    destinatariosBase: [],
    search: "",
    mensajesEnviados: [],
    mensajesRecibidos: [],
    mensajesRecibidosFilter: [],
    mensajesEliminados: [],
    borradores: [],
    mensajesSeleccionadosEliminados: [],
    mensaje: {
      asunto: "",
      cuerpo: "",
      destinatarios: [],
      adjuntos: [],
    },
    borrador: null,

    //countdown
    changesCounter: 0,
    isBorradorSection: false,
    countdown: null,
    countdownId: null,
  }),
  methods: {
    ...mapActions("login", ["parametroComponente"]),
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    async onSelectedItem(value) {
      // alert(value);

      this.selectedItem = value;
      this.isViewMessaje = false;

      if(value != 3) this.isBorradorSection = false
      else this.isBorradorSection = true

      if (
        this.mensaje.cuerpo != "" &&
        this.mensaje.cuerpo != undefined
      ){
        await this.guardarBorrador(this.borrador);
        await this.getBorradores();
      }

      this.mensaje = {
          asunto: "",
          cuerpo: "",
          destinatarios: [],
          adjuntos: [],
      };
      this.changesCounter = 0;

      if (value != 3 && value > 0) this.borrador = null;
      if (value == 1) this.getMensajesRecibidos();
    },
    async loadUsuarios() {
      try {
        let { data } = await axios.get(
          `sistema/usuarioManager/getMain/?id_colegio=${sessionStorage.id_colegio}`
        );
        this.destinatariosBase = data.payload;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    updateMensaje(data) {
    
      this.mensaje.asunto = data.asunto;
      this.mensaje.cuerpo = data.cuerpo;
      this.mensaje.destinatarios = data.destinatarios;
      this.mensaje.adjuntos = data.adjuntos;
    },
    postEnviarMensaje(data) {
      this.updateMensaje(data);
      if (data.info.messageT == "S") {
        this.getMensajesEnviados();
        if (data.borrador != null) {
          this.deleteBorradores([data.borrador]);
        }
      }
    },
    postCancelEmail(msj) {
      this.updateMensaje(msj);
    },
    postChangeMensaje(msj) {
      this.updateMensaje(msj);
    },
    async getMensajesEnviados() {
      try {
        let response = await axios.get(
          `/inicio/mensajeria/enviados/${sessionStorage.id}/`
        );
        this.mensajesEnviados = response.data.map((m) => {
          return {
            id: m.id,
            id_mensaje: m.id,
            adjuntos: m.adjuntos,
            asunto: m.asunto,
            cuerpo: m.cuerpo,
            destinatarios: m.destinatarios,
            descripcion_perfil: m.usuario.perfil.descripcion_perfil,
            nombre_persona: m.usuario.persona.nombre_persona,
            ape1_persona: m.usuario.persona.ape1_persona,
            ape2_persona: m.usuario.persona.ape2_persona,
            fec_us_ing: m.fec_us_ing,
          };
        });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    async getMensajesRecibidos() {
      try {
        let response = await axios.get(
          `/inicio/mensajeria/recibidos/${sessionStorage.id}/`
        );
        this.mensajesRecibidos = response.data.map((m) => {
          return {
            id: m.id,
            id_mensaje: m.id_mensaje,
            adjuntos: m.mensaje.adjuntos,
            asunto: m.mensaje.asunto,
            cuerpo: m.mensaje.cuerpo,
            leido: m.leido,
            destinatarios: m.mensaje.destinatarios,
            descripcion_perfil: m.mensaje.usuario.perfil.descripcion_perfil,
            nombre_persona: m.mensaje.usuario.persona.nombre_persona,
            ape1_persona: m.mensaje.usuario.persona.ape1_persona,
            ape2_persona: m.mensaje.usuario.persona.ape2_persona,
            fec_us_ing: m.mensaje.fec_us_ing,
          };
        });
        this.mensajesRecibidosFilter = [...this.mensajesRecibidos];
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    async getMensajesEliminados() {
      try {
        this.mensajesEliminados = [];
        let response = await axios.get(
          `/inicio/mensajeria/eliminados/${sessionStorage.id}/`
        );
        let recibidos = response.data.recibidos.map((m) => {
          return {
            id: m.id,
            id_mensaje: m.id_mensaje,
            adjuntos: m.mensaje.adjuntos,
            asunto: m.mensaje.asunto,
            cuerpo: m.mensaje.cuerpo,
            leido: m.leido,
            destinatarios: m.mensaje.destinatarios,
            descripcion_perfil: m.mensaje.usuario.perfil.descripcion_perfil,
            nombre_persona: m.mensaje.usuario.persona.nombre_persona,
            ape1_persona: m.mensaje.usuario.persona.ape1_persona,
            ape2_persona: m.mensaje.usuario.persona.ape2_persona,
            fec_us_ing: m.mensaje.fec_us_ing,
            recibido: true,
          };
        });
        let enviados = response.data.enviados.map((m) => {
          return {
            id: m.id,
            id_mensaje: m.id,
            adjuntos: m.adjuntos,
            asunto: m.asunto,
            cuerpo: m.cuerpo,
            destinatarios: m.destinatarios,
            descripcion_perfil: m.usuario.perfil.descripcion_perfil,
            nombre_persona: m.usuario.persona.nombre_persona,
            ape1_persona: m.usuario.persona.ape1_persona,
            ape2_persona: m.usuario.persona.ape2_persona,
            fec_us_ing: m.fec_us_ing,
            recibido: false,
          };
        });
        this.mensajesEliminados = [...recibidos, ...enviados];
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    async getBorradores() {
      try {
        let response = await axios.get(
          `/inicio/mensajeria/borradores/${sessionStorage.id}/`
        );
        this.borradores = response.data.map((m) => {
          return {
            id: m.id,
            id_borrador: m.id,
            adjuntos: m.adjuntos,
            asunto: m.asunto,
            cuerpo: m.cuerpo,
            destinatarios: m.destinatarios.map((d) => d.usuario.id),
            descripcion_perfil: m.usuario.perfil.descripcion_perfil,
            nombre_persona: m.usuario.persona.nombre_persona,
            ape1_persona: m.usuario.persona.ape1_persona,
            ape2_persona: m.usuario.persona.ape2_persona,
            fec_us_ing: m.fec_us_ing,
          };
        });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    //methods for countdown borrador save
    async startCountdown() {
      this.clearCountdownTimer();
      this.countdown = 10;
      this.countdownId = setInterval(async () => {
        this.countdown--;
        if (this.countdown === 0) {
          this.clearCountdownTimer();

          // this.saveDraft();
          // funcion para guardar 
          // eslint-disable-next-line no-extra-boolean-cast
          if (!!this.mensaje.cuerpo) {
            await this.guardarBorrador(this.borrador)
          }
        }
      }, 1000);
    },
    async resetCountdown(cuerpoGada) {
      this.changesCounter++
      if (cuerpoGada != "" && cuerpoGada != undefined && this.borrador && this.isBorradorSection && ![1].includes(this.changesCounter)) {
        this.countdown = 5;
        if (!this.countdownId) {
          await this.startCountdown();
        }
      }
    },
    clearCountdownTimer() {
      if (this.countdownId) {
        clearInterval(this.countdownId);
        this.countdownId = null;
      }
    },
    async saveDraft() {
      // funcion para guardar 
      // eslint-disable-next-line no-extra-boolean-cast
      if (!!this.mensaje.cuerpo) {
        await this.guardarBorrador(this.borrador)
      }
    },
  
  
    openModalDeleteMensajes(mensajesSeleccionados) {
      this.mensajesSeleccionadosEliminados = mensajesSeleccionados;
      this.modalDelete = true;
    },
    volver() {
      this.isViewMessaje = false;
    },
    async deleteMensajes() {
      try {
        let data = await axios.post("/inicio/mensajeria/deleteMasive/", {
          id_usuario: sessionStorage.id,
          mensajes: this.mensajesSeleccionadosEliminados.map((m) => {
            return {
              id_mensaje: m.id_mensaje,
              recibido: m.recibido,
            };
          }),
        });
        this.setEnviarMens({
          tipo: data.data.messageT,
          mensaje: `${data.data.message}`,
          tiempo: null,
        });
        this.modalDelete = false;
        if (data.data.messageT == "S") this.getMensajesEliminados();
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    async recicleMensajes(mensajesSeleccionados, isEnviado) {
      try {
        let data = await axios.post("/inicio/mensajeria/recicleMasive/", {
          id_usuario: sessionStorage.id,
          mensajes: mensajesSeleccionados.map((m) => m.id_mensaje),
          isEnviado,
        });

        this.setEnviarMens({
          tipo: data.data.messageT,
          mensaje: `${data.data.message}`,
          tiempo: null,
        });
        if (data.data.messageT == "S") {
          this.getMensajesEliminados();
          if (isEnviado == true) {
            this.getMensajesEnviados();
          } else {
            this.getMensajesRecibidos();
          }
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    async guardarBorrador(borrador) {
      try {
        let formData = new FormData();
        formData.append("id_usuario", sessionStorage.id);
        formData.append("id_colegio", sessionStorage.id_colegio);
        formData.append("asunto", this.mensaje.asunto);
        formData.append("cuerpo", this.mensaje.cuerpo);
        for (
          let index = 0;
          index < this.mensaje.destinatarios.length;
          index++
        ) {
          const destinatario_id = this.mensaje.destinatarios[index];
          formData.append("destinatarios", destinatario_id);
        }
        if (this.mensaje.adjuntos) {
          for (let index = 0; index < this.mensaje.adjuntos.length; index++) {
            const archivo = this.mensaje.adjuntos[index];
            formData.append("subirArchivo", archivo);
          }
        }
        // si el usuario está escribiendo inicia un contador para guardar el borrador
        if(borrador){
          formData.append("id_borrador", borrador.id_borrador);

          borrador.adjuntos.forEach(adj => {
            formData.append("rutaArchivosToDelete", adj.uri)
          });

          console.log(formData.getAll("rutaArchivosToDelete"), "gasdasd");
          // eslint-disable-next-line no-unused-vars
          const response = await axios.put("/inicio/mensajeria/borrador/", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
          this.changesCounter = 0;
          if(!this.isBorradorSection) this.borrador = null
          return
        } else {
          await axios.post("/inicio/mensajeria/borradores/", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
          this.borrador = null;
        }

        this.changesCounter = 0;
        this.setEnviarMens({
          tipo: "S",
          mensaje: `Este mensaje fue guardado como un borrador`,
          tiempo: null,
        });



      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    async deleteBorradores(borradoresSeleccionados) {
      try {
        let data = await axios.post("/inicio/mensajeria/deleteBorradores/", {
          id_usuario: sessionStorage.id,
          id_colegio: sessionStorage.id_colegio,
          borradores: borradoresSeleccionados.map((m) => m.id),
        });
        // this.setEnviarMens({ tipo: data.data.messageT, mensaje: `${data.data.message}`, tiempo: null });
        if (data.data.messageT == "S") await this.getBorradores();
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    filtrarMensajesNoLeidos() {
      this.mensajesRecibidosFilter = [
        ...this.mensajesRecibidos.filter((d) => d.leido == false),
      ];
    },
    marcarLeido(item) {
      try {
        let index = this.mensajesRecibidos.findIndex(
          (m) => m.id_mensaje == item.id_mensaje
        );
        this.mensajesRecibidos[index].leido = true;
        axios.put(`/inicio/mensajeria/marcar/${item.id_mensaje}/`, {
          id_usuario: sessionStorage.id,
        });
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    selectMensaje(item, isBorrador) {
      if (isBorrador == true) {
        this.selectedItem = 0;
        this.updateMensaje(item);
        this.borrador = item;
      } else {
        this.borrador = null;
        this.isViewMessaje = true;
      }
    },
  },
  mounted() {
    this.loadUsuarios();
    this.getMensajesRecibidos();
    this.getMensajesEnviados();
    this.getMensajesEliminados();
    this.getBorradores();
  },
  computed: {
    totalRecibidos() {
      return this.mensajesRecibidos.length;
    },
    totalBorradores() {
      return this.borradores.length;
    },
  },
  watch: {
    // 'mensaje.cuerpo': function(newVal) {
    //   // this.changesCounter++

    //   // if (newVal != "" && newVal != undefined && this.borrador && this.isBorradorSection && ![1,2].includes(this.changesCounter)) {
    //   //   console.log(newVal, "newValaa");
    //   //   this.resetCountdown();
    //   // }
    // },

    countdown(newVal) {
      console.log(newVal, "thiscountdownwatcher");
    }
  },
  destroyed() {
    if (
      this.mensaje.cuerpo != "" &&
      this.mensaje.cuerpo != undefined &&
      this.borrador == null
    )
      this.guardarBorrador(this.borrador);

    // this.clearCountdownTimer();
  },
  beforeDestroy() {
    this.clearCountdownTimer();
  },
};
</script>
